import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TEXT = [
  "The web",
  "has become",
  "a landfill",
  "of templates —",
  "slow,",
  "identical,",
  "forgettable.",
  "Z Crazy",
  "builds the",
  "opposite:",
  "static,",
  "hand-coded",
  "sites that",
  "load in a blink",
  "and linger",
  "in memory",
  "like a scene",
  "you can't",
  "stop quoting.",
];

const ACCENTS = new Set([2, 7, 10, 11, 13, 16]);

const Word = ({ children, progress, index, total, accent }) => {
  const start = index / total;
  const end = (index + 1.2) / total;
  const opacity = useTransform(progress, [start, end], [0.18, 1]);
  const color = useTransform(progress, [start, end], [
    accent ? "#54371a" : "#30323a",
    accent ? "#FF9E00" : "#F4F4F2",
  ]);
  return (
    <motion.span
      style={{ opacity, color }}
      className="inline-block mr-[0.28em]"
    >
      {children}
    </motion.span>
  );
};

const ManifestoSection = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.8", "end 0.3"],
  });

  return (
    <section
      id="manifesto"
      ref={ref}
      data-testid="manifesto-container"
      className="relative py-40 sm:py-56 overflow-hidden"
    >
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 1 }}
          className="mono-label mb-10"
        >
          — 01 / Manifesto
        </motion.div>

        <h2
          data-testid="manifesto-text"
          className="font-display font-light tracking-tight leading-[1.02] text-[clamp(2.2rem,5.8vw,5.8rem)] max-w-[22ch]"
        >
          {TEXT.map((w, i) => (
            <Word
              key={i}
              progress={scrollYProgress}
              index={i}
              total={TEXT.length}
              accent={ACCENTS.has(i)}
            >
              {w}
            </Word>
          ))}
        </h2>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="mt-20 grid md:grid-cols-2 gap-10 max-w-[900px] text-[16px] leading-relaxed text-[#8A8D98]"
        >
          <p>
            No React runtimes shipped to visitors. No 3 MB hero videos. No
            cookie banners the size of a dialog box. Every byte is on trial —
            if it doesn't earn its place, it doesn't ship.
          </p>
          <p>
            We write HTML, CSS and a razor-thin layer of JavaScript by hand.
            The result is sites that score 100 in Lighthouse, look like a
            film still, and keep ranking long after the trend cycle moves on.
          </p>
        </motion.div>
      </div>

      {/* Giant faded backing wordmark */}
      <div className="absolute left-0 right-0 -bottom-16 flex justify-center pointer-events-none">
        <div className="wordmark-giant">MANIFESTO</div>
      </div>
    </section>
  );
};

export default ManifestoSection;
